import * as actionTypes from "./actionTypes";
import * as types from "./types";

export const fetchGroupUsersRequest = (group: string): types.FetchGroupUsersRequest => ({
    type: actionTypes.FETCH_GROUP_USERS_REQUEST,
    group: group
});

export const fetchGroupUsersSuccess = (group: string, payload: types.FetchGroupUsersSuccessPayload): types.FetchGroupUsersSuccess => ({
    type: actionTypes.FETCH_GROUP_USERS_SUCCESS,
    group: group,
    payload
});

export const fetchGroupUsersFailure = (group:string, payload: types.FetchGroupUsersFailurePayload): types.FetchGroupUsersFailure => ({
    type: actionTypes.FETCH_GROUP_USERS_FAILURE,
    group: group,
    payload
});
